import { 
    CHANGE_USER_PROFILE_FAILURE,
    CHANGE_USER_PROFILE_REQUEST,
    CHANGE_USER_PROFILE_SUCCESS,
    GET_ALL_USER_FAILURE,
    GET_ALL_USER_REQUEST,
    GET_ALL_USER_SUCCESS,
    GET_BUSINESSENTITY_FAILURE,
    GET_BUSINESSENTITY_REQUEST,
    GET_BUSINESSENTITY_SUCCESS,
    GET_USER_FAILURE, 
    GET_USER_REQUEST, 
    GET_USER_SUCCESS,
    LOGIN_FAILURE, 
    LOGIN_REQUEST, 
    LOGIN_SUCCESS, 
    LOGOUT, 
    REGISTER_FAILURE, 
    REGISTER_REQUEST, 
    REGISTER_SUCCESS, 
    SEND_OTP_FRGTP_FAILURE, 
    SEND_OTP_FRGTP_REQUEST, 
    SEND_OTP_FRGTP_SUCCESS,
    CHANGE_FRGTP_FAILURE, 
    CHANGE_FRGTP_REQUEST, 
    CHANGE_FRGTP_SUCCESS, 
    VRFYACCTS_FAILURE, 
    VRFYACCTS_REQUEST,
    VRFYACCTS_SUCCESS,
    CHG_USER_ROLE_REQUEST,
    CHG_USER_ROLE_SUCCESS,
    CHG_USER_ROLE_FAILURE} from "./ActionType"

const initialState={
    user:null,
    chgrole:null,
    entity:null,
    isLoading:false,
    error:null,
    jwt:null,
    vrfy:null,
    vrfyOTP:null,
    customers: []
}

export const authReducer=(state=initialState, action)=>{

    switch(action.type){
        case REGISTER_REQUEST:
        case VRFYACCTS_REQUEST:
        case SEND_OTP_FRGTP_REQUEST:
        case CHANGE_FRGTP_REQUEST:
        case LOGIN_REQUEST:
        case GET_ALL_USER_REQUEST:
        case CHANGE_USER_PROFILE_REQUEST:
        case GET_BUSINESSENTITY_REQUEST:
        case GET_USER_REQUEST:
        case CHG_USER_ROLE_REQUEST:
            return {...state, isLoading:true, error:null}

        case REGISTER_SUCCESS:
        case LOGIN_SUCCESS:
            return {...state, isLoading:false, error:null, jwt:action.payload}

        case SEND_OTP_FRGTP_SUCCESS:
        case CHANGE_FRGTP_SUCCESS:
            return {...state, isLoading:false, error:null, vrfy:action.payload }
                
        case VRFYACCTS_SUCCESS:
            return {...state, isLoading:false, error:null, vrfyOTP:action.payload}    

        case GET_USER_SUCCESS:
        case CHANGE_USER_PROFILE_SUCCESS:
            return {...state, isLoading:false, error:null, user:action.payload}
        
        case CHG_USER_ROLE_SUCCESS:
            return {...state, isLoading:false, error:null, chgrole:action.payload}

        case GET_BUSINESSENTITY_SUCCESS:
            return {...state, isLoading:false, error:null, entity:action.payload}

        case GET_ALL_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                customers: action.payload
              }
              
        case REGISTER_FAILURE:
        case VRFYACCTS_FAILURE:
        case SEND_OTP_FRGTP_FAILURE:
        case CHANGE_FRGTP_FAILURE:
        case LOGIN_FAILURE:
        case GET_ALL_USER_FAILURE:
        case CHANGE_USER_PROFILE_FAILURE:
        case GET_BUSINESSENTITY_FAILURE:
        case GET_USER_FAILURE:
        case CHG_USER_ROLE_FAILURE:
            return {...state, isLoading:false, error:action.payload}

        case LOGOUT:
            return {...initialState}

        default:
            return state;
    }
}